// Copyright (c) 2020 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const updateTemporaryObjectKey = (state, action) =>
    action.temporaryObjectKey;

export default (state = getClaimDefaultState().temporaryObjectKey, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_TRACK_TEMPORARY_OBJECT_KEY]: updateTemporaryObjectKey
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/track/reducers/temporary-object-key.js